import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SHowCFPPService {
  Receive_info: Subject<any> = new Subject();
  save_info: Subject<any> = new Subject();
constructor() { }
Show(data){
  this.Receive_info.next({  data:data});
 }

 Receive(data){
  this.Receive_info.next({  data:data});
 }

}
